import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import unitysceen from "../assests/images/unitysceen.png";
import upload from "../assests/images/upload.png";
import uploadUnity from "../assests/images/uploadUnity.png";
import app from "../Firebase";
import Sidebar from "../Components/Sidebar";
import file from "../assests/images/unitysceen.png";
import { RiDeleteBin6Line } from "react-icons/ri";
import { BsCloudUploadFill } from "react-icons/bs";
import Constant from "../Components/Utils/Constant";
import { RiLoader2Fill } from "react-icons/ri";
import CustomSpinner from "../Components/CustomSpinner";
import SlidingProgressBar from "../Components/CustomProgressbar";
import { Link, useParams } from "react-router-dom";
import { MdArrowDropDown } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import EditCategoryForm from "./EditCategoryForm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Context, { contextProvider } from "../Components/Context";
import { RiArrowDownSFill } from "react-icons/ri";
import ReactPaginate from "react-paginate";

export default function Unitymodals3D({ video }) {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVideos, setSelectedVideos] = useState([]);

  // pop up form
  const [showPopup, setShowPopup] = useState(false);

  const handleShowPopup = () => setShowPopup(true);
  const handleClosePopup = () => setShowPopup(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [companyname, setCompanyname] = useState("");
  const [category, setCategory] = useState("");
  const [which_type, setWhich_type] = useState("");
  const [access, setAccess] = useState([]);
  const [modelname, setModelname] = useState("");
  const [thumbnail, setThumbnail] = useState(undefined);
  const [model, setModel] = useState(undefined);
  const [thumbnailPerc, setThumbnailPerc] = useState(0);
  const [modelPerc, setModelPerc] = useState(0);
  const [isMainImageUploading, setIsMainImageUploading] = useState(false);
  const [mainImageUploadProgress, setMainImageUploadProgress] = useState(0);
  const [isUnitySceneUploading, setIsUnitySceneUploading] = useState(false);
  const [unitySceneUploadProgress, setUnitySceneUploadProgress] = useState(0);
  const [inputs, setInputs] = useState({});
  const [showEditForm, setShowEditForm] = useState(false);
  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [user, setUser] = useState([]);
  const [totalCount1, setTotalCount1] = useState(null);
  const { video_id } = useParams();
  const { totalCount, setTotalCount } = useContext(contextProvider);
  const [searchUserTerm, setSearchUserTerm] = useState("");
  const [filterUserData, setFilterUserData] = useState([]);
  const [searchCompanyTerm, setSearchCompanyTerm] = useState("");
  const [filterCompanyData, setFilterCompanyData] = useState([]);
  const [searchCategoryTerm, setSearchCategoryTerm] = useState("");
  const [filterCategoryData, setFilterCategoryData] = useState([]);
  const [userName, setUserName] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [customCategory, setCustomCategory] = useState("");
  const [uniqueCategories, setUniqueCategories] = useState([]);
  const [customCompanyname, setCustomCompanyname] = useState("");
  const [uniqueCompanynames, setUniqueCompanynames] = useState([]);
  const [dropdownOpenCompany, setDropdownOpenCompany] = useState(false);
  const [selectedItemCompany, setSelectedItemCompany] = useState(null);
  const [editPopup, setEditPopup] = useState(false);
  const [modelmanager, setModelmanager] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [createdby, setCreatedby] = useState(" ");
  const handleModelTypeChange = (event) => {
    const selectedType = event.target.value;
    setWhich_type(selectedType);
  };

  //user get for email
  useEffect(() => {
    const storedName = localStorage.getItem("name");

    if (storedName) {
      setUserName(storedName);
    } else {
      setUserName("Unauthorized");
    }
    const fetchUser = async () => {
      try {
        const response = await fetch(`${Constant.BASE_URL}/user/get`);
        const data = await response.json();

        if (data && data.admins) {
          setUser(data.admins);
          if (data.success) {
            setTotalCount1(data.totalCount);
          }
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUser();
  }, []);

  // check box button
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  // Edit form pop up

  const handleEditCategory = () => {
    setShowEditForm(true);
  };
  const handleCloseEdit = () => {
    setShowEditForm(false);
  };
  // toggle dropdown
  const toggleDropdownfilter = () => {
    setIsDropdownOpenfilter(!isDropdownOpenfilter);
  };

  // Checkbox state

  const [checkboxStates, setCheckboxStates] = useState(user.map(() => false));
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  // Function to handle checkbox change for a specific item
  const handleCheckboxChanged = (index) => {
    const newCheckboxStates = [...checkboxStates];
    newCheckboxStates[index] = !newCheckboxStates[index];
    setCheckboxStates(newCheckboxStates);

    const selectedAccess = user
      .filter((_, i) => newCheckboxStates[i])
      .map((item) => item.email);
    setAccess(selectedAccess);
  };

  // Function to handle "Select All" checkbox change
  const handleSelectAllChanged = () => {
    setSelectAllChecked(!selectAllChecked);
    setCheckboxStates(Array(user.length).fill(!selectAllChecked));

    // Update the access state based on selected checkboxes
    const selectedAccess = user
      .map((item, i) =>
        !selectAllChecked || checkboxStates[i] ? item.email : null
      )
      .filter(Boolean);
    setAccess(selectedAccess);
  };

  const countCheckedUsers = () => {
    const checkedCount = checkboxStates.filter((isChecked) => isChecked).length;
    return checkedCount;
  };

  // for showing checkbox on click of button
  const [showCheckbox, setShowCheckbox] = useState(false);

  const handleButtonClick = () => {
    setShowCheckbox(!showCheckbox);
  };

  // category selection functionalities
  useEffect(() => {
    const uniqueCategories = Array.from(
      new Set(videos.map((item) => item.category))
    );
    const uniqueCategoriesList = uniqueCategories.map((category, index) => ({
      id: index,
      category: category,
    }));
    setUniqueCategories(uniqueCategoriesList);
  }, [videos]);

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
    setFilterCategoryData([]);
  };

  const handleCategorySelect = (item) => {
    setSelectedItem(item);
    setCategory(item.category);
    setDropdownOpen(false);
  };

  const handleCustomCategoryAdd = () => {
    if (customCategory.trim() !== "") {
      const newCategory = {
        id: uniqueCategories.length,
        category: customCategory.trim(),
      };
      setUniqueCategories([...uniqueCategories, newCategory]);
      setSelectedItem(newCategory);
      setCategory(customCategory.trim());
      setDropdownOpen(false);
      setCustomCategory("");
    }
  };

  const handleCustomCategoryChange = (e) => {
    setCustomCategory(e.target.value);
  };

  // select company name dropdown
  useEffect(() => {
    const uniqueCompanyNames = Array.from(
      new Set(videos.map((item) => item.companyname))
    );
    const uniqueCompanynameList = uniqueCompanyNames.map(
      (companyname, index) => ({
        id: index,
        companyname: companyname,
      })
    );
    setUniqueCompanynames(uniqueCompanynameList);
  }, [videos]);

  const handleDropdownToggleCompanyname = () => {
    setDropdownOpenCompany(!dropdownOpenCompany);
    setSearchCompanyTerm("");
    setFilterCompanyData([]);
  };

  const handleCompanyNameSelect = (item) => {
    setSelectedItemCompany(item);
    setCompanyname(item.companyname);
    setDropdownOpenCompany(false);
    setSearchCompanyTerm("");
  };

  const handleCustomCompanynameAdd = () => {
    if (customCompanyname.trim() !== "") {
      const newCompanyname = {
        id: uniqueCompanynames.length,
        companyname: customCompanyname.trim(),
      };
      setUniqueCompanynames([...uniqueCompanynames, newCompanyname]);
      setSelectedItemCompany(newCompanyname);
      setCompanyname(customCompanyname.trim());
      setDropdownOpenCompany(false);
      setSearchCompanyTerm("");
      setCustomCompanyname("");
    }
  };

  const handleCustomCompanynameChange = (e) => {
    setCustomCompanyname(e.target.value);
  };

  // Function to fetch videos based on page number
  const fetchVideos = async (page) => {
    try {
      const response = await fetch(
        `${Constant.BASE_URL}/model/get?page=${page}`
      );
      const data = await response.json();

      setVideos(data.videos);
      setTotalCount(data.totalCount);
      setTotalPages(data.totalPages);
      setCurrentPage(page);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };

  // useEffect to fetch videos initially and whenever the page changes
  useEffect(() => {
    fetchVideos(currentPage);
  }, [currentPage, showPopup, editPopup]);

  // Function to handle page click in pagination
  const handlePageClick = async ({ selected }) => {
    const newPageNumber = selected + 1;
    setCurrentPage(newPageNumber);
  };

  useEffect(() => {
    model && uploadFile(model, "modelUrl");
  }, [model]);

  useEffect(() => {
    thumbnail && uploadFile(thumbnail, "thumbnailUrl");
  }, [thumbnail]);

  const toggleVideoSelection = (videoId) => {
    if (selectedVideos.includes(videoId)) {
      setSelectedVideos(selectedVideos.filter((id) => id !== videoId));
    } else {
      setSelectedVideos([...selectedVideos, videoId]);
    }
  };

  //  deleting image and model to firebase
  const deleteSelectedVideos = async () => {
    try {
      // Send DELETE request to delete videos on the server side
      await axios.delete(`${Constant.BASE_URL}/model/delete`, {
        data: { ids: selectedVideos },
      });

      // Delete files from Firebase Storage
      const storage = getStorage(app);
      await Promise.all(
        selectedVideos.map(async (videoId) => {
          const video = videos.find((v) => v._id === videoId);
          if (video) {
            const thumbnailRef = ref(storage, video.thumbnail);
            const modelRef = ref(storage, video.model);

            await deleteObject(thumbnailRef);
            await deleteObject(modelRef);
          }
        })
      );

      setVideos((prevVideos) =>
        prevVideos.filter((video) => !selectedVideos.includes(video._id))
      );
      setSelectedVideos([]);
      toast.success("Unity Model Deleted Sucessfully!");
    } catch (error) {
      console.error("Error deleting videos:", error);
    }
  };

  //  uploading image and model to firebase
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size <= 200 * 1024) {
        // 200 KB in bytes
        setThumbnail(file);
        setModelname(file.name);
        setSelectedImage(URL.createObjectURL(file));
      } else {
        // Notify the user that the selected image is too large
        toast.error("Please select an image below 200 KB.");
        // Optionally, clear any previously selected image
        // setModelname('');
        // setSelectedImage('');
      }
    }
  };

  const uploadFile = (file, fileType) => {
    const storage = getStorage(app);
    let folder;

    if (fileType === "thumbnailUrl") {
      folder = "thumbnail/";
    } else if (fileType === "modelUrl") {
      folder = "model/";
    } else if (fileType === "unitySceneUrl") {
      folder = "unityScene/";
    }

    const fileName = new Date().getTime() + file.name;
    const storageRef = ref(storage, folder + fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (fileType === "thumbnailUrl") {
          setThumbnailPerc(Math.round(progress));
        } else if (fileType === "modelUrl") {
          setModelPerc(Math.round(progress));
        } else if (fileType === "unitySceneUrl") {
          setUnitySceneUploadProgress(Math.round(progress));
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setInputs((prev) => {
            return {
              ...prev,
              [fileType]: downloadURL,
            };
          });
        });
      }
    );
  };

  const handleClear = () => {
    if (selectedImage === !null) {
      setSelectedImage(null);
    }
    if (model === !null) {
      setModel(null);
    }
  };

  // post data to mongodb
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${Constant.BASE_URL}/model/upload`, {
        companyname,
        modelname: model.name,
        category,
        which_type,
        access,
        model: inputs.modelUrl,
        thumbnail: inputs.thumbnailUrl,
        createdby: userName,
      });

      if (response.status === 201) {
        handleClosePopup();
        setCompanyname("");
        setModelname("");
        setCategory("");
        setWhich_type("");
        setCheckboxStates(user.map(() => false));
        setAccess([]);
        setThumbnail(undefined);
        setModel(undefined);
        setThumbnailPerc(0);
        setModelPerc(0);
        setIsUnitySceneUploading(true);
        setUnitySceneUploadProgress(0);
        setSelectedImage(null);
        toast.success("Unity Model Created Sucessfully!");
      } else {
        console.log("Failed to submit form. Status:", response.status);
        toast.error("Failed to create Unity Model");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const style = {
    width: `${unitySceneUploadProgress}%`,
    transition: "width 0.1s ease-in-out",
  };

  const style1 = {
    width: `${thumbnailPerc}%`,
    transition: "width 0.1s ease-in-out",
  };

  //user search
  const handleUserSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchUserTerm(searchTerm);

    const filteredData = user.filter((item) =>
      item.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilterUserData(filteredData);
  };

  // category search
  const handleCategorySearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchCategoryTerm(searchTerm);

    const filteredCategories = uniqueCategories.filter((item) =>
      item.category.toLowerCase().includes(searchTerm)
    );
    setFilterCategoryData(filteredCategories);
  };

  const handleCompanySearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchCompanyTerm(searchTerm);

    const filteredCompanyname = uniqueCompanynames.filter((item) =>
      item.companyname.toLowerCase().includes(searchTerm)
    );
    setFilterCompanyData(filteredCompanyname);
  };

  useEffect(() => {
    const fetchModelmanager = async () => {
      try {
        const response = await fetch(`${Constant.BASE_URL}/modelmanager/get`);
        const data = await response.json();
        // setUser(data.admins);
        if (data && data.modelmanager) {
          setModelmanager(data.modelmanager);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchModelmanager();
  }, []);
  const count2DModels = videos.filter(
    (video) => video.which_type === "2D"
  ).length;
  const count3DModels = videos.filter(
    (video) => video.which_type === "3D"
  ).length;
  return (
    <Sidebar>
      <>
        <ToastContainer />
        <div className="p-3 bg-grey-300 lg:p-3 xl:p-3 2xl:p-6">
          <div
            className="bg-white h-[78.55vh]"
            style={{ borderRadius: "0px 0px 11px 11px" }}
          >
            <div className="flex justify-between px-4 py-3 bg-white lg:py-2 xl:py-3 2xl:py-3">
              <div className="flex">
                <Link to="/modelsManager ">
                  <div
                    style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                    className=" px-2 py-2 xl:p-1 flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] 2xl:py-3 2xl:px-2 "
                  >
                    <div className="text-4lg 2xl:text-3xl">
                      <p>
                        Models Manager :{" "}
                        {modelmanager ? modelmanager.length : "0"}
                      </p>
                    </div>
                  </div>
                </Link>
                {/* <Link to="/createModalmanager "> */}

                <Link to="/unitymodels ">
                  <div
                    style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                    className="mx-5 px-2 py-2 xl:p-1 flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] 2xl:py-3 2xl:px-2 "
                  >
                    <div className="text-4lg 2xl:text-3xl">
                      <p>2D Models :{count2DModels}</p>
                    </div>
                  </div>
                </Link>
                <div
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                  }}
                  className="flex items-center justify-center px-2 py-2  border border-white rounded-md cursor-pointer xl:p-1 2xl:py-3 2xl:px-2 "
                >
                  <div className="text-4lg 2xl:text-3xl">
                    <p>3D Models :{count3DModels}</p>
                  </div>
                </div>
                {/* </Link> */}
              </div>
              <div className="flex ">
                <div
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)",
                  }}
                  onClick={handleButtonClick}
                  className="cursor-pointer lg:w-fit px-2 py-2 2xl:py-3 2xl:px-3 text-white flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] "
                >
                  <div className="text-4lg 2xl:text-4xl lg:text-[15px] xl:text-[18px] ">
                    <p>
                      <RiDeleteBin6Line />
                    </p>
                  </div>
                </div>
                <div
                  style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                  disabled={selectedVideos.length === 0}
                  onClick={() => {
                    deleteSelectedVideos();
                  }}
                  className="mx-5  px-2 py-2 xl:p-1 cursor-pointer flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] 2xl:py-3 2xl:px-5 xl:w-fit lg:w-fit"
                >
                  <div className="text-4lg 2xl:text-4xl">
                    <p>Delete</p>
                  </div>
                </div>
                <div
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                  }}
                  onClick={handleShowPopup}
                  className="px-2 py-2 xl:p-1 flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] 2xl:py-3 2xl:px-5 xl:w-fit lg:w-fit"
                >
                  <div className="cursor-pointer text-4lg 2xl:text-4xl">
                    <p>Upload Model</p>
                  </div>
                </div>
              </div>
            </div>
            <hr className="w-full border border-gray-300 " />
            <div className="flex flex-wrap items-center justify-center w-full px-12 py-6  lg:px-5 2xl:px-16">
              <div className="grid grid-cols-6 text-wrap items-start gap-20 w-full lg:gap-15 xl:gap-20 2xl:gap-30 overflow-y-auto lg:h-[65vh] xl:h-[64vh] 2xl:h-[66vh]  scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                {videos
                  .filter((video) => video.which_type === "3D")
                  .map((video) => (
                    <div
                      key={video._id}
                      className="max-w-[150px] flex flex-col items-center text-wrap overflow-wrap cursor-pointer"
                    >
                      <img
                        onClick={() => {
                          setEditPopup(video);
                        }}
                        src={video?.thumbnail}
                        alt=""
                        className="w-[120px] h-[100px] pl-5"
                      />
                      <p
                        style={{ whiteSpace: "normal", wordBreak: "break-all" }}
                        className="text-center"
                      >
                        {video?.modelname}
                      </p>
                      {showCheckbox && (
                        <div className="flex items-center justify-center cursor-pointer">
                          <label className="inline-flex items-center">
                            <input
                              className={`hidden`}
                              type="checkbox"
                              checked={selectedVideos.includes(video._id)}
                              onChange={() => toggleVideoSelection(video._id)}
                            />
                            <div
                              className={`w-5 h-5 bg-white border-2 border-red-500 rounded-sm flex items-center justify-center mr-2 ${
                                selectedVideos.includes(video._id)
                                  ? "bg-red-500"
                                  : ""
                              }`}
                            >
                              {selectedVideos.includes(video._id) && (
                                <div className="w-3 h-3 bg-red-500 rounded-sm"></div>
                              )}
                            </div>
                          </label>
                        </div>
                      )}
                    </div>
                  ))}
                {/* <GetModel/> */}
              </div>
            </div>
          </div>

          {/* Edit form */}
          {editPopup && (
            <EditCategoryForm
              editPopup={editPopup}
              setEditPopup={setEditPopup}
            />
          )}

          {showPopup && (
            <div className="popup-formmodel">
              <div className="flex flex-col items-center justify-center px-10 py-6 bg-white rounded-md w-fit h-fit">
                <h1 className="text-lg font-semibold"> Upload Model</h1>
                <div className="h-[2px] w-full bg-[#959595] mt-2" />
                <form onSubmit={handleSubmit}>
                  <div className="flex flex-row items-center justify-between gap-16 px-4 mt-5">
                    <div className="flex flex-col items-center gap-6">
                      <div
                        onDrop={(e) => handleImageChange(e)}
                        className="flex-col w-40 h-40 bg-white rounded-md shadow-2xl"
                      >
                        <div className="flex flex-col justify-start mx-2 text-sm font-semibold">
                          <div className="pt-2 text-xs font-bold">
                            Thumbnail :
                          </div>
                          <div className="h-[1px] min-w-full bg-[#959595a0]" />
                        </div>

                        <div className="flex items-center mx-2 justify-center h-[110px]">
                          <label htmlFor="thumbnail" className="cursor-pointer">
                            {selectedImage ? (
                              <img
                                alt="upload"
                                src={selectedImage}
                                className="w-32 h-24"
                              />
                            ) : (
                              <img
                                alt="upload"
                                src={upload}
                                className="w-12 h-8"
                              />
                            )}
                          </label>
                          <input
                            id="thumbnail"
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={(e) => {
                              handleImageChange(e);
                            }}
                            required
                          />
                        </div>

                        <div className="flex flex-col justify-end mx-2 text-sm font-semibold">
                          <div className="h-[2px] min-w-full bg-[#959595a0]" />
                          <div className="text-center text-[#959595a0] text-xs">
                            {thumbnail
                              ? thumbnail.name.length > 20
                                ? thumbnail.name.slice(0, 19) + "..."
                                : thumbnail.name
                              : "Upload Thumbnail"}
                          </div>
                        </div>
                        {thumbnailPerc > 0 && (
                          <div className="w-full h-2">
                            <div
                              className="h-full rounded-b-md bg-opacity-70 bg-[#FFB257] transition-width duration-100 ease-in-out"
                              style={style1}
                            ></div>
                          </div>
                        )}
                      </div>
                      <div className="flex-col w-40 h-40 bg-white rounded-md shadow-2xl">
                        <div className="flex flex-col justify-start mx-2 text-sm font-semibold">
                          <div className="pt-2 text-xs font-bold">
                            Upload Model File :
                          </div>
                          <div className="h-[1px] min-w-full bg-[#959595a0]" />
                        </div>
                        <div className="flex mx-2 items-center justify-center h-[110px]">
                          <label htmlFor="model" className="cursor-pointer">
                            {model ? (
                              <img
                                alt="upload"
                                src={unitysceen}
                                className="w-16 h-16"
                              />
                            ) : (
                              <img
                                alt="upload"
                                src={uploadUnity}
                                className="w-16 h-16"
                              />
                            )}
                          </label>
                          <input
                            className="hidden"
                            id="model"
                            type="file"
                            required
                            onChange={(e) => {
                              setIsUnitySceneUploading(true);
                              setUnitySceneUploadProgress(0);
                              setModel(e.target.files[0]);
                              uploadFile(e.target.files[0], "unitySceneUrl");
                            }}
                          />
                        </div>

                        <div className="flex flex-col justify-end mx-2 text-sm font-semibold">
                          <div className="h-[2px] min-w-full bg-[#959595a0]" />
                          <div className="text-center text-[#959595a0] text-xs">
                            {model
                              ? model.name.length > 20
                                ? model.name.slice(0, 19) + "..."
                                : model.name
                              : "No file selected"}
                          </div>
                        </div>
                        {unitySceneUploadProgress > 0 && (
                          <div className="w-full h-2">
                            <div
                              className="h-full rounded-b-md bg-opacity-70 bg-[#FFB257] transition-width duration-100 ease-in-out"
                              style={style}
                            ></div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-col items-start gap-4">
                      <div className="flex items-center justify-end py-3 cursor-pointer">
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3 font-semibold"
                        >
                          Model name :
                        </label>
                        <input
                          disabled
                          value={model ? model.name : "No file selected..."}
                          type="text"
                          id="yourInput"
                          className="flex items-start mb-2 border-b border-gray-500 outline-none"
                          style={{ width: "163px", textAlign: "center" }}
                          placeholder="Super Admin (Auto)"
                        />
                      </div>
                      <div className="flex items-center justify-end py-3 cursor-pointer">
                        <label
                          htmlFor="modelTypeSelect"
                          className="flex items-end px-3 font-semibold"
                        >
                          Model Type:
                          <span className="ml-1 text-red-500">*</span>
                        </label>
                        <select
                          id="modelTypeSelect"
                          className="flex items-start mb-2 border-b border-gray-500 outline-none"
                          style={{ width: "163px", textAlign: "center" }}
                          value={which_type}
                          onChange={handleModelTypeChange}
                        >
                          <option value="">Select Model Type</option>{" "}
                          {/* Add a default option */}
                          <option value="2D">2D</option>
                          <option value="3D">3D</option>
                        </select>
                      </div>
                      <div className="relative flex items-center justify-start py-3 cursor-pointer">
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3 font-semibold"
                        >
                          Category :<span className="ml-1 text-red-500">*</span>
                        </label>
                        <div className="flex pb-1 border-b border-gray-500 outline-none ">
                          <input
                            type="text"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            placeholder="Select category"
                            style={{
                              border: "none",
                              outline: "none",
                              textAlign: "center",
                            }}
                            required
                            disabled
                          />
                          <RiArrowDownSFill
                            onClick={handleDropdownToggle}
                            className="text-xl"
                          />
                          {dropdownOpen && (
                            <div
                              style={{
                                // borderRadius: "0 0 5px 5px",
                                border: "1px solid #0000000a",
                                zIndex: "100",
                              }}
                              className="lg:text-[10px] lg:w-fit xl:text-[15px] py-1 absolute top-9 left-25 bg-white shadow-xl rounded-md overflow-y-auto h-[350px] modelscroll"
                            >
                              <div className=" flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black  bg-white shadow-md border border-black-300 border-opacity-60">
                                <IoIosSearch className="text-xl text-[#D2D2D2]" />
                                <input
                                  type="text"
                                  placeholder="Search..."
                                  onChange={handleCategorySearch}
                                  className="w-[100px] placeholder-[#D2D2D2] bg-transparent outline-none border-none px-2 text-md"
                                />
                              </div>
                              <div className="flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px]  bg-white shadow-md">
                                <input
                                  type="text"
                                  value={customCategory}
                                  onChange={handleCustomCategoryChange}
                                  placeholder="Add custom category"
                                  style={{ border: "none", outline: "none" }}
                                />
                                <button
                                  className="px-2"
                                  onClick={handleCustomCategoryAdd}
                                >
                                  <span className="px-1 border border-grey-200 rounded-sm text-grey-500 text-[10px]">
                                    {" "}
                                    Add
                                  </span>
                                </button>
                              </div>
                              {filterCategoryData?.length > 0
                                ? filterCategoryData.map((item, index) => (
                                    <div
                                      key={item.id}
                                      className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                                      onClick={() => handleCategorySelect(item)}
                                    >
                                      {item.category}
                                    </div>
                                  ))
                                : uniqueCategories.map((item) => (
                                    <div
                                      key={item.id}
                                      className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                                      onClick={() => handleCategorySelect(item)}
                                    >
                                      {item.category}
                                    </div>
                                  ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="relative flex items-center justify-start py-3 cursor-pointer">
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3 font-semibold"
                        >
                          Company Name :
                        </label>
                        <div className="flex pb-1 border-b border-gray-500 outline-none">
                          <input
                            type="text"
                            value={companyname}
                            onChange={(e) => setCompanyname(e.target.value)}
                            placeholder="Select company"
                            style={{
                              border: "none",
                              outline: "none",
                              textAlign: "center",
                            }}
                            disabled
                          />
                          <RiArrowDownSFill
                            onClick={handleDropdownToggleCompanyname}
                            className="text-xl"
                          />
                          {dropdownOpenCompany && (
                            <div
                              style={{
                                border: "1px solid #0000000a",
                                zIndex: "100",
                              }}
                              className="lg:text-[10px] lg:w-fit xl:text-[15px] absolute top-9 left-25 bg-white shadow-xl rounded-md overflow-y-auto h-[280px] modelscroll"
                            >
                              <div className="flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black bg-white shadow-md border border-black-300 border-opacity-60">
                                <IoIosSearch className="text-xl text-[#D2D2D2]" />
                                <input
                                  type="text"
                                  placeholder="Search..."
                                  onChange={handleCompanySearch}
                                  className="w-[100px] placeholder-[#D2D2D2] bg-transparent outline-none border-none px-2 text-md"
                                />
                              </div>
                              <div className="flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black bg-white shadow-md">
                                <input
                                  type="text"
                                  value={customCompanyname}
                                  onChange={handleCustomCompanynameChange}
                                  placeholder="Add custom company"
                                  style={{ border: "none", outline: "none" }}
                                />
                                <button
                                  className="px-2"
                                  onClick={handleCustomCompanynameAdd}
                                >
                                  <span className="px-1 border border-grey-200 rounded-sm text-grey-500 text-[10px]">
                                    {" "}
                                    Add
                                  </span>
                                </button>
                              </div>
                              <div className="overflow-y-auto h-[170px] modelscroll">
                                {filterCompanyData?.length > 0
                                  ? filterCompanyData.map((item, index) => (
                                      <div
                                        key={item.id}
                                        className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                                        onClick={() =>
                                          handleCompanyNameSelect(item)
                                        }
                                      >
                                        {item.companyname}
                                      </div>
                                    ))
                                  : uniqueCompanynames.map((item) => (
                                      <div
                                        key={item.id}
                                        className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                                        onClick={() =>
                                          handleCompanyNameSelect(item)
                                        }
                                      >
                                        {item.companyname}
                                      </div>
                                    ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="relative flex items-center justify-end py-3 cursor-pointer">
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3 font-semibold"
                        >
                          Model Assign to :
                        </label>
                        <div
                          className="flex items-start mb-2 pb-1 text-black border-b border-gray-500 outline-none"
                          style={{ width: "163px", textAlign: "center" }}
                        >
                          {countCheckedUsers()} selected
                          {" " + user?.length}
                        </div>{" "}
                        <div
                          onClick={toggleDropdownfilter}
                          className="absolute bottom-6 right-1 flex justify-center items-center p-[0.2px] bg-[#ffffff] shadow-black shadow-sm rounded-md"
                        >
                          <RiArrowDownSFill className="text-xl" />
                        </div>
                        {isDropdownOpenfilter && (
                          <div
                            style={{
                              border: "1px solid #0000000a",
                              zIndex: "100",
                            }}
                            className="lg:text-[10px] lg:w-fit xl:text-[15px] absolute top-9 left-36 bg-white shadow-xl rounded-md "
                          >
                            {/* Dropdown Options */}
                            <ul className="overflow-y-auto h-[190px] modelscroll py-2">
                              <li className="flex items-center justify-center ">
                                <div className="w-full flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black bg-white shadow-md border border-black-300 border-opacity-60">
                                  <IoIosSearch className="text-xl text-[#D2D2D2]" />
                                  <input
                                    type="text"
                                    placeholder="Search..."
                                    onChange={handleUserSearch}
                                    className="w-[100px] placeholder-[#D2D2D2] bg-transparent outline-none border-none px-2 text-md"
                                  />
                                </div>
                              </li>
                              {/* "Select All" checkbox */}
                              <li className="flex items-center justify-between px-2 py-1 text-black border-t cursor-pointer">
                                <span className="text-[12px]">All</span>
                                <div className="flex items-center justify-end">
                                  <label className="inline-flex items-center">
                                    <div
                                      className={`w-4 h-4 bg-white shadow-md border-red-500 rounded-sm flex items-center justify-center ml-2 ${
                                        selectAllChecked ? "bg-red-500" : ""
                                      }`}
                                    >
                                      {selectAllChecked && (
                                        <div className="w-2 h-2 bg-red-500"></div>
                                      )}
                                    </div>
                                    <input
                                      className="hidden"
                                      type="checkbox"
                                      checked={selectAllChecked}
                                      onChange={handleSelectAllChanged}
                                    />
                                  </label>
                                </div>
                              </li>

                              {filterUserData?.length > 0
                                ? filterUserData.map((item, index) => (
                                    <div
                                      key={item.id}
                                      className="flex items-center justify-between px-2 py-1 text-black border-t border-[#A8A8A8] cursor-pointer"
                                    >
                                      <span className="text-[12px]">
                                        {item.email}
                                      </span>
                                      <div className="flex items-center">
                                        <label className="inline-flex items-center">
                                          <div
                                            className={`w-4 h-4 bg-white  shadow-md border-red-500 rounded-sm flex items-center justify-center ml-2 ${
                                              checkboxStates[index]
                                                ? "bg-red-500"
                                                : ""
                                            }`}
                                          >
                                            {checkboxStates[index] && (
                                              <div className="w-2 h-2 bg-red-500"></div>
                                            )}
                                          </div>
                                          <input
                                            className="hidden"
                                            type="checkbox"
                                            checked={checkboxStates[index]}
                                            onChange={() =>
                                              handleCheckboxChanged(index)
                                            }
                                          />
                                        </label>
                                      </div>
                                    </div>
                                  ))
                                : user.map((item, index) => (
                                    <div
                                      key={item.id}
                                      className="flex items-center justify-between px-2 py-1 text-black border-t border-[#A8A8A8] cursor-pointer"
                                    >
                                      <span className="text-[12px]">
                                        {item.email}
                                      </span>
                                      <div className="flex items-center">
                                        <label className="inline-flex items-center">
                                          <div
                                            className={`w-4 h-4 bg-white border border-black-300 shadow-lg  rounded-sm flex items-center justify-center ml-2 ${
                                              checkboxStates[index]
                                                ? "bg-red-500"
                                                : ""
                                            }`}
                                          >
                                            {checkboxStates[index] && (
                                              <div className="w-2 h-2 bg-red-500"></div>
                                            )}
                                          </div>
                                          <input
                                            className="hidden"
                                            type="checkbox"
                                            checked={checkboxStates[index]}
                                            onChange={() =>
                                              handleCheckboxChanged(index)
                                            }
                                          />
                                        </label>
                                      </div>
                                    </div>
                                  ))}
                            </ul>
                            <button
                              className="flex justify-center w-full bg-white item-center rouded-md py-1"
                              onClick={toggleDropdownfilter}
                            >
                              Apply
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="flex items-center justify-end py-3 cursor-pointer">
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3 font-semibold"
                        >
                          Uploaded By :
                        </label>
                        <input
                          disabled
                          value={userName}
                          type="text"
                          id="yourInput"
                          className="flex items-start mb-2 border-b border-gray-500 outline-none"
                          style={{ width: "163px", textAlign: "center" }}
                          placeholder="Super Admin (Auto)"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center p-1 mt-1 space-x-12 button-container pt-5">
                    <button
                      onClick={handleClosePopup}
                      type="button"
                      className="flex-shrink-0 w-16 text-black bg-white shadow-md loginbtn rounded-sm"
                      style={{
                        background: "(.white.opacity(0.57))",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className={`loginbtn text w-16 flex-shrink-0 rounded-sm ${
                        thumbnailPerc < 100 || modelPerc < 100
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-custom-gradient"
                      }`}
                      style={{
                        background:
                          "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                      }}
                      disabled={thumbnailPerc < 100 || modelPerc < 100}
                    >
                      Create
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </>
      {/* Pagination code*/}
      <div className="flex lg:px-4">
        <div className="w-full  flex  bg-white  bg-white shadow-md backdrop-blur-[5.7px]">
          <div className="w-full  flex  items-center fixed lg:bottom-5 xl:bottom-6 2xl:bottom-6 border-t lg:text-[10px] xl:text-[14px] 2xl:text-3xl lg:pt-1 xl:pt-1 2xl:pt-0">
            <div className="flex justify-start w-full xl:px-5 2xl:p-5">
              <p>
              <span className="text-blue-500">
                Showing {(currentPage - 1) * 1 + 1} </span> to{" "}
                <span className="text-blue-500"> 
                {Math.min(currentPage * 15)} </span> of{" "}
                <span className="text-yellow-500">
                 {count3DModels}
                 </span>{" "}
                entries
              </p>
            </div>
            {/* pagination code */}
            <div className="flex justify-start pr-2 text-blue-500 pagination xl:pr-5">
              <ReactPaginate
                previousLabel={""}
                nextLabel={""}
                breakLabel={"...."}
                pageCount={totalPages}
                marginPagesDisplayed={1}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                className="flex justify-start"
              />
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  );
}
